import { httpClient } from '@/shared/api/httpClient';
import { endpoints } from '@/shared/api/endpoints';

export async function fetchWalletStats() {
  const { data } = await httpClient.get(endpoints.wallet.balance);
  return data;
}

export async function fetchTransactions(filter: Record<string, unknown>) {
  const clean: Record<string, unknown> = {};
  Object.entries(filter).forEach(([k, v]) => {
    if (v !== '' && v != null) clean[k] = v;
  });
  const { data } = await httpClient.get(endpoints.wallet.transactions, {
    params: clean,
  });
  return data;
}

export async function downloadTransactionsCsv() {
  const { data } = await httpClient.get(endpoints.wallet.transactionsCsv, {
    responseType: 'blob',
  });
  return data;
}

export async function fetchInvoice(id: string, type: string) {
  const { data, headers } = await httpClient.get(endpoints.wallet.invoice, {
    params: { invoice: type, walletId: id },
    responseType: 'blob',
  });
  const contentType = String(headers?.['content-type'] || '');
  // API may return JSON error body even with blob responseType
  if (contentType.includes('application/json') || data?.type === 'application/json') {
    const text = await (data as Blob).text();
    let message = 'Failed to load invoice preview';
    try {
      const parsed = JSON.parse(text) as { message?: string };
      if (parsed?.message) message = parsed.message;
    } catch {
      // ignore
    }
    throw new Error(message);
  }
  return data as Blob;
}

export async function fetchSettlements(filter: Record<string, unknown>) {
  const clean: Record<string, unknown> = {};
  Object.entries(filter).forEach(([k, v]) => {
    if (v !== '' && v != null) clean[k] = v;
  });
  const { data } = await httpClient.get(endpoints.wallet.settlements, {
    params: clean,
  });
  return data;
}

export async function fetchWalletChart(params: {
  startDate: string;
  endDate: string;
  reason?: string;
}) {
  const clean: Record<string, string> = {
    startDate: params.startDate,
    endDate: params.endDate,
  };
  if (params.reason) clean.reason = params.reason;
  const { data } = await httpClient.get(endpoints.wallet.monthWise, {
    params: clean,
  });
  return data;
}

export async function depositAmount(payload: { amount: number | string }) {
  const { data } = await httpClient.post(endpoints.wallet.deposit, payload);
  return data;
}

export async function fetchDepositCharges(payload: {
  amount: number;
  userId?: string;
}) {
  const { data } = await httpClient.post(
    endpoints.wallet.depositCharges,
    payload,
  );
  return data;
}

export async function verifyPayment(payload: Record<string, unknown>) {
  const { data } = await httpClient.post(endpoints.wallet.verifyPayment, payload);
  return data;
}

export async function fetchBankDetails() {
  const { data } = await httpClient.get(endpoints.wallet.bankDetailsList);
  return data;
}

export async function addBankDetails(payload: Record<string, unknown>) {
  const { data } = await httpClient.post(endpoints.wallet.bankDetails, payload);
  return data;
}

export async function deleteBankDetails(payload: { bankDetailId: string }) {
  const { data } = await httpClient.delete(endpoints.wallet.deleteBankDetails,{
    data:{
      bankDetailId: payload.bankDetailId,
    }
  } );
  return data;
}

export async function requestWithdrawal(payload: {
  bankDetailId: string;
  amount: number;
}) {
  const { data } = await httpClient.post(
    endpoints.wallet.withdrawalRequest,
    payload,
  );
  return data;
}

export async function fetchWithdrawDeduction(payload: {
  amount: number;
  userId?: string;
}) {
  const { data } = await httpClient.post(
    endpoints.wallet.withdrawDeduction,
    payload,
  );
  return data;
}

export async function fetchTransferCharges(payload: {
  amount: number;
  userId?: string;
}) {
  const { data } = await httpClient.post(
    endpoints.wallet.transferCharges,
    payload,
  );
  return data;
}

export async function transferQndt(payload: {
  userId: string;
  reqAmount: number;
}) {
  const { data } = await httpClient.post(endpoints.wallet.transferQndt, payload);
  return data;
}

export async function searchUsersByEmail(email: string) {
  const { data } = await httpClient.get(endpoints.wallet.searchUsers, {
    params: { email },
  });
  return data;
}
